export const IsMesmaDev = (userSub: string | undefined): boolean => {
    if (userSub === "auth0|49a4eb3f-cda7-4d24-a47f-0b74e12c01e3"
    || userSub ===  "auth0|26a3954a-9b1d-4bc6-8e87-63c449c34433"
    || userSub === "auth0|60a3d4ee0aad37006711e22c" 
    || userSub === "auth0|60a7bf3f228d6500682a94d0"
    || userSub ===   "auth0|685d1fc67a78c6def93030ea" // Robin
    || userSub === "auth0|60d31b35a220150069f55b45"
    || userSub === "auth0|689304ebb35cdf5c52581cd7" // Testcafe Mesma Participant
    || userSub === "auth0|65646049b5823837950a37e9"
    ) {
        return true;
    } else {
        return false;
    } 
}